module.exports = __webpack_public_path__ + "files/51c4ab203f9003ce49cc9e66b05c4968.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-800italic.woff
// module id = 883
// module chunks = 60